import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bf-auth" }
const _hoisted_2 = { class: "bf-auth__form-wrap" }
const _hoisted_3 = { class: "bf-auth__card" }
const _hoisted_4 = { class: "bf-field" }
const _hoisted_5 = { class: "bf-field" }
const _hoisted_6 = { class: "password-tips" }
const _hoisted_7 = { class: "bf-field" }
const _hoisted_8 = {
  key: 0,
  class: "bf-auth__error"
}
const _hoisted_9 = {
  key: 0,
  class: "password-suggestions"
}
const _hoisted_10 = { class: "bf-auth__signup" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"bf-auth__brand\" data-v-1d61217c><div class=\"bf-auth__brand-inner\" data-v-1d61217c><img class=\"bf-auth__brand-logo\" src=\"/img/brand/bindfy_logo_new_white.png\" alt=\"Bindfy\" data-v-1d61217c><h2 data-v-1d61217c>Comece a integrar em minutos.</h2><p data-v-1d61217c> Crie sua conta e conecte seus sistemas com uma plataforma feita para escalar o fluxo dos seus dados. </p></div><div class=\"bf-auth__blob bf-auth__blob--1\" data-v-1d61217c></div><div class=\"bf-auth__blob bf-auth__blob--2\" data-v-1d61217c></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("img", {
          class: "bf-auth__logo-mobile",
          src: "/img/brand/bindfy_logo_new_purple.png",
          alt: "Bindfy"
        }, null, -1)),
        _cache[10] || (_cache[10] = _createElementVNode("h1", { class: "bf-auth__title" }, "Criar conta", -1)),
        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "bf-auth__desc" }, "Preencha os dados para começar", -1)),
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.handleSubmit()), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[4] || (_cache[4] = _createElementVNode("label", null, "E-mail", -1)),
            _createVNode(_component_TextInput, {
              label: 'Digite o seu e-mail',
              type: 'email',
              modelValue: _ctx.signUpForm.login,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signUpForm.login) = $event)),
              "error-messages": 
                _ctx.v$.login.$errors ? _ctx.v$.login.$errors[0]?.$message : undefined
              
            }, null, 8, ["modelValue", "error-messages"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("label", null, "Senha", -1)),
            _createVNode(_component_TextInput, {
              label: 'Digite a sua senha',
              type: 'password',
              modelValue: _ctx.signUpForm.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signUpForm.password) = $event)),
              "error-messages": 
                _ctx.v$.password.$errors
                  ? _ctx.v$.password.$errors[0]?.$message
                  : undefined
              
            }, null, 8, ["modelValue", "error-messages"]),
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", {
                class: _normalizeClass({ passed: _ctx.signUpForm.password.length >= 6 })
              }, " Pelo menos 6 caracteres ", 2),
              _createElementVNode("li", {
                class: _normalizeClass({ passed: /[A-Z]/.test(_ctx.signUpForm.password) })
              }, " Letra maiúscula ", 2),
              _createElementVNode("li", {
                class: _normalizeClass({ passed: /[a-z]/.test(_ctx.signUpForm.password) })
              }, " Letra minúscula ", 2),
              _createElementVNode("li", {
                class: _normalizeClass({ passed: /\d/.test(_ctx.signUpForm.password) })
              }, "Número", 2),
              _createElementVNode("li", {
                class: _normalizeClass({
                  passed: /['!@#$%^&*(),.?':{}|<>]/.test(_ctx.signUpForm.password),
                })
              }, " Caractere especial ", 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[6] || (_cache[6] = _createElementVNode("label", null, "Confirme a senha", -1)),
            _createVNode(_component_TextInput, {
              label: 'Digite a sua senha novamente',
              type: 'password',
              modelValue: _ctx.signUpForm.confirmationPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.signUpForm.confirmationPassword) = $event)),
              "error-messages": 
                _ctx.v$.confirmationPassword.$errors
                  ? _ctx.v$.confirmationPassword.$errors[0]?.$message
                  : undefined
              
            }, null, 8, ["modelValue", "error-messages"]),
            (_ctx.passwordMismatch)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, " As senhas não coincidem. "))
              : _createCommentVNode("", true)
          ]),
          (_ctx.passwordSuggestions)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passwordSuggestions, (suggestion, idx) => {
                  return (_openBlock(), _createElementBlock("li", { key: idx }, _toDisplayString(suggestion), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_PrimaryButton, {
            "is-loading": _ctx.isLoading,
            disabled: _ctx.passwordMismatch,
            label: "Criar conta"
          }, null, 8, ["is-loading", "disabled"]),
          _createElementVNode("div", _hoisted_10, [
            _cache[8] || (_cache[8] = _createTextVNode(" Já possui uma conta? ", -1)),
            _createVNode(_component_router_link, {
              to: "/autenticar/acessar",
              class: "bf-link"
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" Faça o login ", -1)
              ]))]),
              _: 1
            })
          ])
        ], 32)
      ])
    ])
  ]))
}